import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseGoodsReceiveNoteActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/GoodsReceiveNote/GoodsReceiveNoteBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseGoodsReceiveNote"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseGoodsReceiveNote"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseGoodsReceiveNoteActivity)
